import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postalMailActions, authActions, masterActions } from "../../_store";
import { useLocation } from "react-router-dom";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import CustomLoader from "../../components/common/ui/Loader";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import PdfViewer from "../../components/common/PdfViewer/PdfViewer";
import ApproveImg from "../../assets/svg/approve-icon.svg";
import RejectImg from "../../assets/svg/reject.svg";
import { StoredProcedures } from "../../_helpers/enumerator";
import { formatDateTimeAMPM } from "../../utils/formatTime";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";
import { getStoredValue } from "../../_helpers/storagehelper";

const ViewPostalMail = () => {
  const dispatch = useDispatch();

  const location = useLocation();

  const { postalMailInfo, loading, base64data } = useSelector(
    (x) => x.postalMail
  );
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  const MailingID = location?.state?.MailScanningDocumentID;
  //Management User Access Permission selector
  const { PostalMailAccessPermission } = useManagementUserAccessPermission();

  // Hide or Show Approve and Reject buttons
  const shouldShowBtnReviews =
    Array.isArray(PostalMailAccessPermission) && PostalMailAccessPermission?.length > 0
      ? PostalMailAccessPermission?.some(
        (item) =>
          item?.SubMenuName === "Review" && item?.SubMenuActiveStatus === 1
      )
      : true;

  useEffect(() => {
    if (MailingID) {
      dispatch(postalMailActions.GetPostalMailInfo(MailingID));
    }
  }, [MailingID]);

  useEffect(() => {
    if (postalMailInfo && postalMailInfo.DocumentPath) {
      const filePath = postalMailInfo.DocumentPath.slice(
        0,
        postalMailInfo.DocumentPath.lastIndexOf("/") + 1
      );

      dispatch(
        postalMailActions.DownloadFileFromPath({
          folderPath: filePath,
          filename: postalMailInfo.DocumentFileName,
        })
      );
    }
  }, [postalMailInfo]);



  const handleBack = () => {
    history.navigate("/Admin/PostalMailList");
  };

  const handleApprove = () => {

    const shouldShowBtnReviews =
      Array.isArray(PostalMailAccessPermission) && PostalMailAccessPermission?.length > 0
        ? PostalMailAccessPermission?.some(
          (item) =>
            item?.SubMenuName === "Review" &&
            item?.SubMenuActiveStatus === 1
        )
        : true;
    if (!shouldShowBtnReviews) {
      showToastNotification(
        "Review option has been disabled by the admin.",
        "error"
      );
      return;
    }
    Popup({
      title: "Message",
      text: "Are you sure you want to approve?",
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: async () => {
        try {
          const response = await dispatch(
            postalMailActions.ApprovePostalMail({
              mailScanningDocumentID: MailingID,
              modifiedBy: user.ManagementUserID,
            })
          );

          const responseMessages = {
            1: () => {
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName:
                    StoredProcedures?.ApproveorRejectMailDocument,
                  UserAction: `Approved Postal Mail Document (MailScanningDocumentID - ${MailingID})`,
                })
              );
              dispatch(
                masterActions.GetLoadNotificationAlert({
                  ManagementUserID: user?.ManagementUserID,
                  FacilityID: commonFacilityCode,
                })
              ).then((response) => {
                const updatedMenuList =
                  getStoredValue("menu_list") ||
                  response?.payload;

                if (updatedMenuList) {
                  dispatch(authActions.updateMenuList(updatedMenuList));
                }
              });

              showToastNotification(
                "Postal mail has been approved successfully",
                "success"
              );
              history.navigate("/Admin/PostalMailList");
            },
            "-1": () =>
              showToastNotification(
                "Something went wrong. Please try again.",
                "error"
              ),
            "-2": () =>
              showToastNotification(
                "This postal document has already been approved.",
                "error"
              ),
            "-3": () =>
              showToastNotification(
                "This postal document has already been rejected.",
                "error"
              ),
            "-4": () =>
              showToastNotification(
                "This postal document has already been deleted.",
                "error"
              ),
          };

          // Execute the corresponding action based on response code
          (
            responseMessages[response?.payload?.IsSucceed] ||
            (() =>
              showToastNotification(
                "Unknown response. Please try again.",
                "error"
              ))
          )();
        } catch (error) {
          showToastNotification(
            "An unexpected error occurred. Please try again later.",
            "error"
          );
        }
      },
    });

  };

  const handleReject = () => {
    const shouldShowBtnReviews =
      Array.isArray(PostalMailAccessPermission) && PostalMailAccessPermission?.length > 0
        ? PostalMailAccessPermission?.some(
          (item) =>
            item?.SubMenuName === "Review" &&
            item?.SubMenuActiveStatus === 1
        )
        : true;
    if (!shouldShowBtnReviews) {
      showToastNotification(
        "Review option has been disabled by the admin.",
        "error"
      );
      return;
    }
    Popup({
      title: "Message",
      text: "Are you sure you want to reject?",
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: async () => {
        try {
          const response = await dispatch(
            postalMailActions.RejectPostalMail({
              mailScanningDocumentID: MailingID,
              modifiedBy: user.ManagementUserID,
            })
          );

          const responseMessages = {
            1: () => {
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName:
                    StoredProcedures?.ApproveorRejectMailDocument,
                  UserAction: `Rejected Postal Mail Document (MailScanningDocumentID - ${MailingID})`,
                })
              );
              showToastNotification(
                "Postal mail has been rejected successfully",
                "success"
              );

              dispatch(
                masterActions.GetLoadNotificationAlert({
                  ManagementUserID: user?.ManagementUserID,
                  FacilityID: commonFacilityCode,
                })
              ).then((response) => {
                const updatedMenuList =
                  getStoredValue("menu_list") ||
                  response?.payload;

                if (updatedMenuList) {
                  dispatch(authActions.updateMenuList(updatedMenuList));
                }
              });
              history.navigate("/Admin/PostalMailList");
            },
            "-1": () =>
              showToastNotification(
                "Something went wrong. Please try again.",
                "error"
              ),
            "-2": () =>
              showToastNotification(
                "This postal document has already been approved.",
                "error"
              ),
            "-3": () =>
              showToastNotification(
                "This postal document has already been rejected.",
                "error"
              ),
            "-4": () =>
              showToastNotification(
                "This postal document has already been deleted.",
                "error"
              ),
          };

          // Execute the corresponding action based on response code
          (
            responseMessages[response?.payload?.IsSucceed] ||
            (() =>
              showToastNotification(
                "Unknown response. Please try again.",
                "error"
              ))
          )();
        } catch (error) {
          showToastNotification(
            "An unexpected error occurred. Please try again later.",
            "error"
          );
        }
      },
    });

  };

  if (loading) {
    return <CustomLoader />;
  }
  return (
    <>
      <div className="card  shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space">
          <h2 className="form_title_uppercase text-color">
            MAIL DOCUMENT INFORMATION
          </h2>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <Button
              variant="primary"
              className="me-2"
              label={"Back"}
              type={"button"}
              status={"primary"}
              onClick={handleBack}
              disabled={false}
              icon={"fa-solid fa-angle-left"}
            />
          </div>
        </div>
        <div className=" mt-3 w-100 mb-4">
          {/* Content Section */}

          <div className="row m-0">
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
              <div className="d-flex flex-wrap align-items-center">
                <label className="flex-shrink-0 postalmail-text">
                  Facility Code
                </label>
                <strong className="postalmail-text">
                  {postalMailInfo?.FacilityCode || "-"}
                </strong>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
              <div className="d-flex flex-wrap align-items-center">
                <label className="flex-shrink-0 postalmail-text">
                  Inmate ID
                </label>
                <strong className="postalmail-text">
                  {postalMailInfo?.InmateResidentId || "-"}
                </strong>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
              <div className="d-flex flex-wrap align-items-center">
                <label className=" flex-shrink-0 postalmail-text">
                  Inmate Name
                </label>
                <strong className="postalmail-text">
                  {postalMailInfo?.InmateFullName || "-"}
                </strong>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
              <div className="d-flex flex-wrap align-items-center">
                <label className=" flex-shrink-0 postalmail-text">
                  Mail From
                </label>
                <strong className="postalmail-text">
                  {postalMailInfo?.MailFrom || "-"}
                </strong>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
              <div className="d-flex flex-wrap align-items-center">
                <label className=" flex-shrink-0 postalmail-text">
                  Uploaded By
                </label>
                <strong className="postalmail-text">
                  {postalMailInfo?.UploadedName || "-"}
                </strong>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
              <div className="d-flex flex-wrap align-items-start">
                <label className=" flex-shrink-0 postalmail-text">
                  Uploaded Date
                </label>
                <strong className="postalmail-text">
                  {formatDateTimeAMPM(postalMailInfo?.UploadedDate) || "-"}
                </strong>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
              <div className="d-flex flex-wrap align-items-center">
                <label className=" flex-shrink-0 postalmail-text">
                  Document Status
                </label>
                <strong className="postalmail-text">
                  {{
                    0: "Pending",
                    1: "Approved",
                    2: "Rejected",
                    3: "Deleted",
                  }[postalMailInfo?.IsApprove] || "-"}
                </strong>
              </div>
            </div>
            {postalMailInfo?.IsApprove === 1 &&
              (postalMailInfo?.IsLegalMail ? (
                <div className="col-md-4">
                  <div className="d-flex flex-wrap align-items-center">
                    <label className=" flex-shrink-0 postalmail-text">
                      Legal Mail
                    </label>
                    <strong className="postalmail-text">Yes</strong>
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-md-4">
                    <div className="d-flex flex-wrap align-items-center">
                      <label className=" flex-shrink-0 postalmail-text">
                        Approved By
                      </label>
                      <strong className="postalmail-text">
                        {postalMailInfo?.ApproveOrRejectName || "-"}
                      </strong>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex flex-wrap align-items-center">
                      <label className=" flex-shrink-0 postalmail-text">
                        Approved Date
                      </label>
                      <strong className="postalmail-text">
                        {formatDateTimeAMPM(
                          postalMailInfo?.ApproveOrRejectDate
                        ) || "-"}
                      </strong>
                    </div>
                  </div>
                </>
              ))}
            {postalMailInfo?.IsApprove === 2 && (
              <>
                <div className="col-md-4">
                  <div className="d-flex flex-wrap align-items-center">
                    <label className=" flex-shrink-0 postalmail-text">
                      Rejected By
                    </label>
                    <strong cclassName="postalmail-text">
                      {postalMailInfo?.ApproveOrRejectName || "-"}
                    </strong>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex flex-wrap align-items-center">
                    <label className=" flex-shrink-0 postalmail-text">
                      Rejected Date
                    </label>
                    <strong className="postalmail-text">
                      {formatDateTimeAMPM(
                        postalMailInfo?.ApproveOrRejectDate
                      ) || "-"}
                    </strong>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {(shouldShowBtnReviews && base64data) && (
          <div className="d-flex flex-wrap justify-content-center mt-2">
            <>
              {(postalMailInfo?.IsApprove === 0 ||
                postalMailInfo?.IsApprove === 2) && (
                  <Button
                    variant="primary"
                    className="me-2"
                    label={"Approve"}
                    type={"button"}
                    status={"success"}
                    onClick={handleApprove}
                    imgsrc={ApproveImg}
                    disabled={false}
                  ></Button>
                )}
            </>
            {(postalMailInfo?.IsApprove === 0 ||
              (postalMailInfo?.IsApprove === 1 &&
                !postalMailInfo?.IsLegalMail)) && (
                <Button
                  variant="primary"
                  className="me-2"
                  label={"Reject"}
                  type={"button"}
                  imgsrc={RejectImg}
                  status={"primary"}
                  onClick={handleReject}
                  disabled={false}
                ></Button>
              )}
          </div>
        )}

        <div>
          {base64data ? (
            <PdfViewer data={base64data} />
          ) : (
            <p className="text-center text-red fs-3 fw-bold p-2">
              No document available
            </p>
          )}
        </div>
        {(shouldShowBtnReviews && base64data) && (
          <div className="d-flex flex-wrap justify-content-center mt-2">
            <>
              {(postalMailInfo?.IsApprove === 0 ||
                postalMailInfo?.IsApprove === 2) && (
                  <Button
                    variant="primary"
                    className="me-2"
                    label={"Approve"}
                    type={"button"}
                    status={"success"}
                    onClick={handleApprove}
                    imgsrc={ApproveImg}
                    disabled={false}
                  ></Button>
                )}
            </>
            {(postalMailInfo?.IsApprove === 0 ||
              (postalMailInfo?.IsApprove === 1 &&
                !postalMailInfo?.IsLegalMail)) && (
                <Button
                  variant="primary"
                  className="me-2"
                  label={"Reject"}
                  type={"button"}
                  imgsrc={RejectImg}
                  status={"primary"}
                  onClick={handleReject}
                  disabled={false}
                ></Button>
              )}
          </div>
        )}

      </div>
    </>
  );
};

export default React.memo(ViewPostalMail);
